import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import FormStylingJS from "@widgets/form/FormStylingJS";
import PageH1 from "@components/seo/PageH1";
const ContactPageDescriptionText = ({ title, description }) => {
    FormStylingJS();
    return title || description ? (_jsxs("div", { className: "contact-description-text", children: [title && (_jsx(PageH1, { fallbackElement: "h2", className: "contact-description-text-title", children: title })), description && _jsx("div", { className: "contact-description-text-body-content", dangerouslySetInnerHTML: { __html: description } })] })) : null;
};
export default ContactPageDescriptionText;
